module.exports = __webpack_public_path__ + "d6723c9ad6a950fe41a60216be87ac84.svg";